import produce from 'immer';

import {
  PAYMENT_TYPE_CREATE_FAILURE,
  PAYMENT_TYPE_FETCH_FAILURE,
  PAYMENT_TYPE_FETCH_SUCCESS,
  PAYMENT_TYPE_LIST_EDIT_SEQUENCE_FAILURE,
  PAYMENT_TYPE_LIST_EDIT_SEQUENCE_SUCCESS,
  PAYMENT_TYPE_LIST_FETCH_FAILURE,
  PAYMENT_TYPE_LIST_FETCH_SUCCESS,
} from '@actions/paymentType';

const initialState: IConfigPaymentTypeStore = {
  currentPaymentType: null,
  paymentTypes: [],
  error: null,
};

export default (state: IConfigPaymentTypeStore = initialState, action: any) =>
  produce(state, (draftState: IConfigPaymentTypeStore) => {
    switch (action.type) {
      case PAYMENT_TYPE_LIST_FETCH_SUCCESS:
      case PAYMENT_TYPE_LIST_EDIT_SEQUENCE_SUCCESS:
        draftState.paymentTypes = action.response;
        draftState.error = null;

        return;

      case PAYMENT_TYPE_FETCH_SUCCESS:
        draftState.currentPaymentType = action.response;
        draftState.error = null;

        return;

      case PAYMENT_TYPE_CREATE_FAILURE:
        draftState.error = action.error;

        return;

      case PAYMENT_TYPE_FETCH_FAILURE:
        draftState.error = action.error;

        return;

      case PAYMENT_TYPE_LIST_EDIT_SEQUENCE_FAILURE:
        draftState.error = action.error;

        return;

      case PAYMENT_TYPE_LIST_FETCH_FAILURE:
        draftState.paymentTypes = null;
        draftState.error = action.error;

        return;
    }
  });
